import { Box, Button, Group, MultiSelect, Select } from '@mantine/core';
import { IconFilterCancel } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';

const SiteProviderStatusFilter = ({ providers, onFilter }) => {
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [selectedState, setSelectedState] = useState('ALL');

  useEffect(() => {
    onFilter({ selectedProviders, selectedState });
  }, [selectedProviders, selectedState, onFilter]);

  const handleClear = () => {
    setSelectedProviders([]);
    setSelectedState('ALL');
  };

  return (
    <Box pos="relative">
      <Group>
        <MultiSelect
          label="廠商"
          placeholder="全部"
          data={providers.map((v) => ({ value: v.id, label: v.name }))}
          value={selectedProviders}
          onChange={setSelectedProviders}
          searchable
          clearable
        />
        <Select
          label="狀態"
          placeholder="全部"
          data={[
            { value: 'ALL', label: '全部' },
            { value: 'ENABLED', label: '已設定' },
            { value: 'DISABLED', label: '尚未設定' },
          ]}
          value={selectedState}
          onChange={setSelectedState}
        />
      </Group>
      <Box pos="absolute" top={0} right={0}>
        <Button
          variant="outline"
          size="xs"
          onClick={handleClear}
          leftSection={<IconFilterCancel size={14} />}
        >
          清除篩選
        </Button>
      </Box>
    </Box>
  );
};

export default SiteProviderStatusFilter;
